import { Checkbox } from "antd";

import React from "react";
import styled from "styled-components";
import { Option } from "../../../shared/interface";
import { theme } from "../../../theme";
import { MIN_MORNITOR_WIDTH } from "../../constants";
import { InputValue } from "../Inputs/InputArray";
import { InputPropsType } from "../Inputs/InputPropsT";

export interface CheckBoxProps extends InputPropsType {
  onChange?: (e: any[]) => void;
  checkBoxArray?: InputValue[];
  options?: Option[];
}

const CheckButton: React.FC<CheckBoxProps> = ({
  children,
  disabled,
  placeholder,
  name,
  value,
  options,
  checkBoxArray,
  onChange,
}) => {
  const styles = {
    disabled,
    placeholder,
    name,
    value,
  };

  return (
    <CheckboxInput {...styles} value={value} onChange={onChange}>
      {/* childre이 있을 경우 children */}
      {/* children이 없을 경우 map으로 자식들을 순회함 */}

      {options
        ? options.map((val) => (
            <StyledCheckBox
              key={val.value}
              value={val.value}
              checked={
                value?.filter(
                  (checkedValue: string) => checkedValue === val.value
                ).length > 0
              }
            >
              {val.label}
            </StyledCheckBox>
          ))
        : checkBoxArray
        ? (checkBoxArray as InputValue[]).map((e) => (
            <StyledCheckBox
              key={e.id}
              value={e.value}
              checked={
                value?.filter((val: string) => val === e.value).length > 0
              }
            >
              {e.value}
            </StyledCheckBox>
          ))
        : children}
    </CheckboxInput>
  );
};

export default CheckButton;

const CheckboxInput = styled(Checkbox.Group)<{ $wrap?: boolean }>`
  width: 100%;
  height: 100%;
  display: flex;
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    justify-content: flex-start;
    align-items: center;
    min-width: 340px;
  }
  align-items: center;
  .ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin: 4px 8px 0px 0px;
  }
  .ant-checkbox-wrapper {
    margin: 4px 8px 0px 0px;
  }
  flex-wrap: wrap;
  justify-content: flex-start;
  transition: all 0.3s;
`;
const StyledCheckBox = styled(Checkbox)<{ checked: boolean }>`
  border: 1px solid #6a1cfc;
  box-sizing: border-box;
  border-radius: 100px;
  ${theme.typo.button.m16};
  padding: 6px 16px;
  transition: all 0.3s;
  min-width: fit-content;
  & > span.ant-checkbox {
    display: none;
  }

  margin-top: 8px;
  border-color: ${({ checked }) =>
    checked ? theme.colors.mainPrimary3 : theme.colors.gray6};
  color: ${({ checked }) =>
    checked ? theme.colors.mainPrimary3 : theme.colors.gray6};
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    ${theme.typo.button.m16};
    justify-content: center;
    align-items: center;
  }
`;
